import React from "react";
import { Link } from "react-router-dom";
import bgImg from "../../../images/bgImg.png";
import qualityImg from "../../../images/services-img/Layer_1.png";

const QualityAssurance = () => {
  return (
    <section
      className="w-full relative overflow-hidden bg-[#1E6C56]"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 sm:pt-18 lg:pt-20 pb-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-end">
          {/* Left Column: Text & CTA */}
          <div
            className="lg:col-span-6 flex flex-col justify-center pb-10 sm:pb-12 lg:pb-16"
            data-aos="fade-right"
          >
            <span className="text-[#F5C955] text-sm sm:text-base font-black tracking-[0.2em] uppercase mb-3 sm:mb-4 block font-['Axiforma',sans-serif]">
              QUALITY ASSURANCE
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[40px] xl:text-[44px] font-extrabold text-white tracking-tight leading-[1.15] font-['Axiforma',sans-serif] mb-6">
              Quality You Can Rely On
            </h2>
            <div className="space-y-4 text-white/90 text-sm sm:text-base leading-relaxed font-normal mb-8 max-w-xl">
              <p>
                All of our in-office language services follow structured workflows
                and quality-control processes. Our team works according to
                project-specific instructions, linguistic guidelines, and client
                requirements to ensure that every deliverable is accurate,
                consistent, and fit for purpose.
              </p>
              <p>
                Whether you need human translation, transcription, voice data,
                linguistic review, or post-editing of machine-generated content,
                our team provides the expertise and quality assurance needed to
                deliver dependable language solutions.
              </p>
            </div>
            <div>
              <Link
                to="/contact-us"
                className="inline-flex items-center justify-center px-8 py-3.5 rounded-2xl bg-white text-gray-900 font-semibold text-sm sm:text-base shadow-md hover:bg-gray-100 hover:shadow-lg transition-all duration-200 active:scale-95"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Right Column: Illustration Layer_1 */}
          <div
            className="lg:col-span-6 flex items-end justify-center lg:justify-end self-end w-full"
            data-aos="fade-left"
          >
            <img
              src={qualityImg}
              alt="Quality You Can Rely On"
              className="block w-full max-w-lg sm:max-w-xl lg:max-w-2xl xl:max-w-3xl h-auto object-contain select-none pointer-events-none mb-6 sm:mb-8 lg:mb-10"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualityAssurance;
